// extracted by mini-css-extract-plugin
export default {"pagination":"pagination_pagination__Pj-Yu","pagination_list":"pagination_pagination_list__8gyTQ","pagination_list__content":"pagination_pagination_list__content__hHkSl"};